import whitePaperPdf from './pdf/Fitrizer_V10.pdf';

const Pdf = {
    whitePaperPdf
}

export default Pdf;